<app-document-viewer-page label="Politica de privacidad" [url]="url" *ngIf="url && url.length > 0">
</app-document-viewer-page>

